import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

window.sliders = [];

window.addEventListener('load', (event) => {
    const btns = document.querySelectorAll('img.hover-replace');
    for (let i = 0; i < btns.length; i++) {
        if (undefined !== btns[i].src) {
            btns[i].addEventListener('mouseover', function(e) {
                e.currentTarget.src = e.currentTarget.src.replace('_off','_on');
            });
            btns[i].addEventListener('mouseout', function(e) {
                e.currentTarget.src = e.currentTarget.src.replace('_on','_off');
            });
        }
    }

    // .card-hotel-main は専用スクリプト (admin/js/editor/blocks/card/sample.js)
    // が thumbs 連動付きで初期化するため、ここでは対象外にする（二重初期化防止）
    const sliders = document.querySelectorAll('.slider:not(.card-hotel-main):not(.card-hotel-thumbs)');
    for (let i = 0; i < sliders.length; i++) {
        let id = sliders[i].getAttribute('id');
        if (!id) {
            id = 'slider-' + i;
            sliders[i].setAttribute('id', id);
        }
        sliders[i].classList.add('swiper');
        const pagination = document.createElement("div");
        pagination.classList.add('swiper-pagination');
        sliders[i].appendChild(pagination);

        window.sliders[i] = new Swiper('#' + id, {
            modules: [Pagination, Autoplay],
            loop: true,
            speed: 800,
            slidesPerView: 1,
            centeredSlides: false,
            watchOverflow: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '#' + id + ' .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            breakpoints: {
            },
        });
    }

    const hostname = location.hostname;
    const elements = document.getElementsByTagName('a');
    for(let element of elements){
        let href = element.getAttribute('href');
        if(href && href.startsWith('http') && href.indexOf(hostname) === -1) {
            //a要素にtarget="_blank"を追加する
            element.setAttribute('target', '_blank');
            //a要素にrel="noopener noreferrer"を追加する
            element.setAttribute('rel', 'noopener noreferrer');
        }
    }
});